'use client';

//* Styles
import RecipesTemplateStyle from './style';

//* Components
import Hero from '../components/Hero';
import List from '../components/List';
import CallToAction from '@/modules/_sections/CallToAction';

const RecipesTemplate = ({ pageData, itemsData }) => {
	const { title, description } = pageData;
	const { data } = itemsData;

	return (
		<RecipesTemplateStyle>
			<Hero
				title={title}
				description={description}
			/>

			<List data={data} />

			<CallToAction />
		</RecipesTemplateStyle>
	);
};

export default RecipesTemplate;
